import { Button, Card, CardHeader, PageHeader } from '../components/ui';
import { Notice } from '../components/form';
import { Icon } from '../components/Icon';

/**
 * 机队入口。
 *
 * 控制台**不自建机队数据** —— 实时遥测、位置与指令都在运营监管平台完成。
 * 这里只做一件事：把人送过去，并说清两边的分工。
 */
export function FleetPage() {
  return (
    <div className="space-y-5">
      <PageHeader
        title="机队"
        description="机队的实时数据不在控制台。控制台负责账号与权限，监管平台负责飞行。"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
        <Card>
          <CardHeader title="职责分工" hint="这条边界是刻意的，不是还没做完" />
          <ul className="space-y-3 text-[13px]">
            {[
              ['控制台（本页）', '账号、成员、角色、组织、接入应用、登录与操作记录。'],
              ['运营监管平台', '机队总览、无人机注册、单机实时遥测、指令下发与告警阈值。'],
            ].map(([title, detail]) => (
              <li key={title} className="rounded-control bg-nest-2 px-4 py-3">
                <p className="font-medium text-fg">{title}</p>
                <p className="mt-1 text-fg-muted">{detail}</p>
              </li>
            ))}
          </ul>

          <div className="mt-5">
            <a href="https://havorix.work" target="_blank" rel="noreferrer">
              <Button variant="primary" icon="external">
                前往运营监管平台
              </Button>
            </a>
          </div>
        </Card>

        <div className="space-y-5">
          <Card>
            <CardHeader title="登录方式" />
            <Notice tone="info">
              目前两个系统各自登录。控制台已经是标准 OIDC Provider，
              监管平台接入后即可用同一套账号单点登录 —— 这一步在监管平台侧完成，控制台不需要改动。
            </Notice>
            <dl className="mt-4 space-y-2 text-[13px]">
              <div className="flex justify-between gap-3">
                <dt className="text-fg-muted">Issuer</dt>
                <dd className="truncate font-mono text-xs text-fg">{window.location.origin}</dd>
              </div>
              <div className="flex justify-between gap-3">
                <dt className="text-fg-muted">发现文档</dt>
                <dd className="truncate font-mono text-xs text-fg">/.well-known/openid-configuration</dd>
              </div>
            </dl>
          </Card>

          <Card>
            <CardHeader title="组织隔离" />
            <p className="text-[13px] text-fg-muted">
              令牌里带有组织声明（<code className="font-mono">org</code>）与组织内角色（
              <code className="font-mono">org_role</code>），下游系统据此判断「这条数据属于谁」。
              控制台本身不保存任何飞行数据。
            </p>
          </Card>
        </div>
      </div>

      <p className="flex items-center gap-1.5 text-xs text-fg-subtle">
        <Icon name="help" className="h-3.5 w-3.5" />
        我们不销售无人机整机；机队相关咨询请走「工单与支持」。
      </p>
    </div>
  );
}
